<template>
  <div
    class="upload-form-container ... max-h-[90vh] overflow-y-auto ml-[10rem] mr-[10rem]"
  >
    <!-- Modal header -->
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-lg font-medium">Video yuklash</h2>
      <button class="text-gray-500" @click="closeModal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <!-- Video upload area -->
    <div class="mb-8">
      <div
        class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center"
        @dragover.prevent
        @drop.prevent="onFileDrop"
        @click="!selectedFileName && triggerFileInput"
      >
        <div v-if="selectedFileName">
          <span>{{ selectedFileName }}</span>
        </div>
        <div
          v-if="!selectedFileName"
          class="flex flex-col items-center justify-center"
        >
          <img src="@/assets/image/cloud_icon.png" alt="" />
          <p class="text-sm text-gray-600 mb-1">
            Faylni tanlang yoki shu yerga olib tashlang
          </p>
          <p class="text-xs text-gray-500">
            JPEG, PNG, GIF, MP4 formatlari, maksimal hajmi 50 MB gacha
          </p>
          <button
            class="mt-4 px-4 py-2 bg-indigo-600 text-white rounded-md text-sm hover:bg-indigo-700"
            @click.stop="triggerFileInput"
          >
            Faylni tanlang
          </button>
          <input
            type="file"
            ref="fileInput"
            class="hidden"
            @change="onFileSelected"
            accept="video/*,image/*"
          />
        </div>
      </div>
    </div>

    <!-- Options Tabs -->
    <div class="grid grid-cols-2 gap-2 mb-8">
      <div
        class="border border-dashed border-gray-300 rounded-lg p-4 cursor-pointer flex flex-col-reverse items-center"
        @click="!coverFileName && triggerCoverInput()"
      >
        <div v-if="coverFileName">
          <span>{{ coverFileName }}</span>
        </div>
        <div v-if="!coverFileName" class="flex flex-col-reverse items-center">
          <div class="flex-1">
            <h3 class="text-base font-medium mb-1 text-center">Muqova</h3>
            <p class="text-xs text-gray-500 text-center">
              JPEG, PNG, GIF, MP4 formatlari, 50MB gacha
            </p>
          </div>
          <img
            src="@/assets/image/image-upload.png"
            class="h-6 w-6 mt-2"
            alt=""
          />
          <input
            ref="coverInput"
            type="file"
            class="hidden"
            @change="onCoverSelected"
            accept="image/*,video/*"
          />
        </div>
      </div>
      <div
        class="border border-dashed border-gray-300 rounded-lg p-4 cursor-pointer flex flex-col-reverse items-center"
      >
        <div class="flex flex-col-reverse items-center">
          <div class="flex-1">
            <h3 class="text-base font-medium mb-1 text-center">
              Videodan olingan rasm
            </h3>
            <p class="text-xs text-gray-500">
              Muqova uchun videodan kadr tanlang
            </p>
          </div>
          <img src="@/assets/image/mingcute_screenshot-line.png" alt="" />
        </div>
      </div>
    </div>

    <!-- Title and description -->
    <div class="mb-6">
      <h3 class="text-base font-medium mb-4">Nomi va tavsifi</h3>
      <div class="mb-4">
        <input
          type="text"
          placeholder="Nomi"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
          v-model="videoTitle"
        />
      </div>
      <div>
        <textarea
          placeholder="Video haqida ma'lumot"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 h-24"
          v-model="videoDescription"
        ></textarea>
      </div>
    </div>
    <div class="mb-8">
      <h3 class="text-base font-medium mb-4">Narxni kiriting</h3>
      <div>
        <input
          type="number"
          placeholder="Narxi"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
          v-model="price"
        />
      </div>
    </div>
    <!--    spinner-->
    <div
      v-if="isSubmitting"
      class="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center"
    >
      <div class="flex flex-col items-center">
        <svg
          class="animate-spin h-8 w-8 text-indigo-600 mb-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <p class="text-white text-sm">Yuklanmoqda...</p>
      </div>
    </div>
    <button
      class="w-full py-3 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors mb-[50px]"
      @click="submitForm"
      :disabled="isSubmitting"
    >
      {{ isSubmitting ? "Saqlanmoqda..." : "Saqlash" }}
    </button>
  </div>
</template>

<script>
import http from "@/http";

export default {
  data() {
    return {
      coverFile: null,
      coverFileName: null,
      selectedFile: null,
      categoryInput: "",
      selectedFileName: null,
      videoTitle: "",
      videoDescription: "",
      selectedCategorySection: null,
      price: "",
      isSubmitting: false,
      categories: {
        "Питание для здоровья": false,
        "Фитнес тренировки": false,
        "Здоровье психики": false,
        "Управление стрессом": false,
        "Секреты питания": false,
        "Готовим вместе": false,
        "Здоровый образ жизни": false,
        "Планировка питания": false,
        "Снижение веса": false,
        "Тренировка в зале": false,
        "Здоровые привычки": false,
        "Спорт и хобби": false,
      },
      subcategories: {
        "Домашние тренировки": false,
        "Тренировки для новичков": false,
        "Истории мотивации": false,
        "Экономия времени": false,
        "Истории похудения": false,
        "Кулинарные тренировки": false,
        "Функциональные тренировки": false,
      },
    };
  },
  methods: {
    triggerCoverInput() {
      this.$refs.coverInput.click();
    },
    onCoverSelected(event) {
      this.coverFileName = event.target.files[0].name;
      this.coverFile = event.target.files[0];
      console.log("Cover selected:", this.coverFileName);
    },
    closeModal() {
      this.$emit("close");
      this.$router.push("/main/studio");
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      this.selectedFileName = event.target.files[0].name;
      console.log(this.selectedFile);
    },
    onFileDrop(event) {
      this.selectedFile = event.dataTransfer.files[0];
    },
    toggleCategory(category) {
      this.categories[category] = !this.categories[category];
      this.selectedCategorySection = this.categories[category]
        ? category
        : null;
    },
    toggleSubcategory(subcategory) {
      this.subcategories[subcategory] = !this.subcategories[subcategory];
    },
    addCategory() {
      if (this.categoryInput && !this.categories[this.categoryInput]) {
        this.categories[this.categoryInput] = false;
        this.categoryInput = "";
      }
    },
    async submitForm() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("wrapper", this.coverFile);
      formData.append("title", this.videoTitle);
      formData.append("description", this.videoDescription);
      formData.append("price", this.price);
      formData.append("categories", "[]");
      formData.append("subcategories", "[]");

      try {
        const response = await http.post(
          "/video/upload-multiple-file",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Upload successful", response);
        this.closeModal();
      } catch (error) {
        console.error("Upload failed", error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.upload-form-container {
  max-width: 100%;
  padding: 1.5rem;
  background-color: white;
  border-radius: 0.5rem;
}
</style>
